import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { LockManagerService } from '@core/lock-manager/lock-manager.service';

export const canDeactivateLockScreenGuard: CanDeactivateFn<any> = (): boolean =>
	!inject(LockManagerService).isLocked.getValue();
